export default {
  url: 'https://kyeloivc7zd5bpw5vrzwpijj7m.appsync-api.us-east-1.amazonaws.com/graphql',
  apiKey: 'da2-23leeu4ffvbjvk2hyo2f6m5ldy'
}
